import * as actionTypes from "../ActionTypes";

const initialState = {
  getLoanType: [],
};

const store = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_LOAN_TYPE_INIT:
      return {
        ...state,
      };
    case actionTypes.GET_LOAN_TYPE_SUCCESS:
      return {
        ...state,
        getLoanType: action.payload,
      };
    case actionTypes.GET_LOAN_TYPE_FAIL:
      return {
        ...state,
        error: "",
      };
    default:
      return state;
  }
};

export default store;
